import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TicketService } from './../../shared/services/ticket.service';
import { BookingService } from './../../shared/services/booking.service';

@Component({
  selector: 'app-ticket-view',
  templateUrl: './ticket-view.component.html',
  styleUrls: ['./ticket-view.component.scss']
})
export class TicketViewComponent implements OnInit, OnDestroy {
  fetching: { [key: string]: any } = {};
  ticket: any;
  booking: any;
  usesvg = false;
  constructor(
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private ticketService: TicketService,
    private bookingService: BookingService
  ) {}

  ngOnInit() {
    this.fetching['getTicket'] = this.activatedRoute.params.subscribe(params => {
      // console.log(params['ticketId']);
      if (params['ticketId']) {
        this.ticketService
          .getOneById(params['ticketId'])
          .then(res => {
            // console.log(res.data());
            if (res.data()) {
              this.ticket = res.data();
              this.bookingService
                .getOneById(this.ticket.bookingId)
                .then(resbb => {
                  this.booking = resbb.data();
                  // console.log(this.booking);
                })
                .catch(err => {
                  console.log(err);
                });
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    });
  }

  ngOnDestroy() {
    for (const key in this.fetching) {
      if (this.fetching.hasOwnProperty(key) && this.fetching[key]) {
        this.fetching[key].unsubscribe();
      }
    }
  }

  backClicked() {
    this.location.back();
  }

  chnageUsesvg() {
    if (this.usesvg) {
      this.usesvg = false;
    } else {
      this.usesvg = true;
    }
  }
}
